import styled from 'styled-components';
import colors from '@kiper/theme/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    ${colors.primary50} 0%,
    ${colors.secondary50} 100%
  );
  padding: 20px;
`;

export const ErrorCard = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 48px 32px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const IconWrapper = styled.div`
  color: ${colors.danger500};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: ${colors.danger50};
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.secondary900};
  margin: 0;
`;

export const Description = styled.p`
  font-size: 16px;
  color: ${colors.secondary600};
  line-height: 1.5;
  margin: 0;
`;

export const ActionButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  background: ${colors.porterSecondary};
  color: ${colors.white};
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${colors.porterPrimary};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(55, 74, 160, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
